// extracted by mini-css-extract-plugin
export default {"card":"ViewCard_card__JrlYp","inner":"ViewCard_inner__kMyxA","image":"ViewCard_image__kumjf","message":"ViewCard_message__Z7jXQ","signature":"ViewCard_signature__Q26ZH"};